(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["galapet-recent"] && !Shopify.designMode) return;
  try {
    
function initRecent(root=document){root.querySelectorAll('.gp-recent').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const track=section.querySelector('.gp-recent__track');const buttons=section.querySelectorAll('[data-gp-scroll]');const update=()=>{buttons[0].disabled=track.scrollLeft<=1;buttons[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};buttons.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.gpScroll)*track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update();});}initRecent();document.addEventListener('shopify:section:load',()=>initRecent());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
